import React from "react";
import PropTypes from 'prop-types';

const Bird = props => (
  <svg className={props.className} width={props.width} height={props.height} viewBox="0 0 16 13">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-639.000000, -392.000000)" fill="#FFFFFF">
            <g transform="translate(450.000000, 170.000000)">
                <g>
                    <g transform="translate(75.000000, 206.000000)">
                        <g transform="translate(114.000000, 12.000000)">
                            <path d="M14.4761905,6.29411765 C14.7929646,5.65208333 15.3151091,5.00885417 15.2380952,4 C14.925196,4.61953125 14.2233524,4.89375 13.7142857,4.76470588 C12.873914,4.39947917 12.0194957,4 11.4285714,4 C9.26297944,4 7.79487179,5.46927083 7.61904762,7.05882353 C7.79487179,7.53776042 7.82199619,7.78828125 7.61904762,7.82352941 C5.1502437,7.89322917 2.72939182,6.58645833 0.761904762,4.76470588 C0.830684467,5.08333333 0.667938122,5.64869792 0.761904762,6.29411765 C0.667938122,7.38541667 1.25111252,8.39088542 2.28571429,9.35294118 C1.59016741,8.96640625 1.08158508,8.81744792 0.761904762,8.58823529 C0.640813732,10.2020833 1.77325705,11.5257812 3.04761905,11.6470588 C3.00063573,11.9015625 2.70904853,11.9421875 2.28571429,11.6470588 C2.2004662,11.9421875 1.99364272,11.921875 1.52380952,11.6470588 C2.21063785,13.1846354 3.42445433,14.1325521 4.57142857,13.9411765 C3.73977538,15.0398438 2.32252596,15.5645833 0.761904762,15.4705882 C0.518753973,15.5645833 0.257681712,15.5476563 0,15.4705882 C1.44776436,16.4583333 3.17355372,17 5.33333333,17 C11.070142,17 14.3725366,11.9997396 14.4761905,7.82352941 C14.3725366,7.52083333 14.369146,7.37864583 14.4761905,7.05882353 C15.0031786,6.77604167 15.5592287,6.20052083 16,5.52941176 C15.4100445,5.80104167 14.7794024,5.97708333 14.4761905,6.29411765 Z" id="bird"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
  </svg>
);

Bird.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
}

Bird.defaultProps = {
  width: 16,
  height: 13,
  className: ""
}

export default Bird;



// WEBPACK FOOTER //
// ./src/components/svgs/Bird.js